import React, { Component, PropTypes } from 'react';

import '../../../node_modules/codemirror/mode/xml/xml';
import '../../../node_modules/codemirror/mode/javascript/javascript';
import '../../../node_modules/codemirror/mode/css/css';
import '../../../node_modules/codemirror/mode/htmlmixed/htmlmixed';
import '../../../node_modules/codemirror/addon/fold/foldcode';
import '../../../node_modules/codemirror/addon/fold/foldgutter';
import '../../../node_modules/codemirror/addon/fold/brace-fold';
import '../../../node_modules/codemirror/addon/fold/indent-fold';
import '../../../node_modules/codemirror/addon/fold/xml-fold';
import '../../../node_modules/codemirror/addon/fold/comment-fold';

import Codemirror from 'react-codemirror';

export default class CodeMirrorItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        var options = this.props.options || {
                lineNumbers: true,
                mode: 'htmlmixed',
                viewportMargin: Infinity,
                foldGutter: true,
                gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
            };
        return (
            <Codemirror value={this.props.htmlContent} onChange={this.props.updateCode} options={options} />
        );
    }
}

CodeMirrorItem.propTypes = {
    htmlContent: React.PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./client/components/CodeMirrorItem.js